import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'

import Logger from 'core/utils/Logger'

import { IJBPMAP } from '../../../models/IJBPPMAP'
import {
  EMPTY_MAP_PLACEHOLDER,
  MAP_FRACTION_DIGITS,
  OVERALL_CATEGORY,
  PLANNING_BY_FY_FQ,
} from '../../config'

interface IGetMapValue {
  mapData: IJBPMAP[]
  fy: number
  category: string
  subCategory: string
  l3Category: string
  fq: number
  isUnits: boolean
}

export const getMapValue = ({
  mapData,
  fy,
  category,
  subCategory,
  l3Category,
  fq,
  isUnits = false,
}: IGetMapValue): string => {
  let result = EMPTY_MAP_PLACEHOLDER

  const unitStr = isUnits ? 'Unit' : ''
  let fieldName = `${unitStr}Q${fq}`
  if (fq === PLANNING_BY_FY_FQ) {
    fieldName = `${unitStr}FY`
  }

  const mapDataFiltered = mapData.filter(
    (el) =>
      el.FYear === fy &&
      el.Category === category &&
      el.SubCategory === subCategory &&
      (subCategory === OVERALL_CATEGORY || el.Market === l3Category || !l3Category)
  )
  if (mapDataFiltered.length >= 1) {
    if (mapDataFiltered.length > 1) {
      Logger.log(`Duplicated market growth data: ${mapDataFiltered.length}`)
    }
    const fieldValue = mapDataFiltered[0][fieldName]
    if (fieldValue) {
      const formattedValue = formatMoneyInteger(fieldValue, MAP_FRACTION_DIGITS)
      result = `${formattedValue}%`
    }
  }

  return result
}
